import React from 'react';
import PropTypes from 'prop-types';
import { get, sample } from 'lodash';
import withData from '@bd/bdcore-data';
import { SanitizeHtml, buildThumbnailUrl } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
// import PageHelmet from '@bd/bdcore-pagehelmet';

import PageHelmet from '@bd/bdcore-pagehelmet';


import Header from '../../components/Header';
import Footer from '../../components/Footer';
import CtaBanner from '../../components/CtaBanner';
import TestimonialBanner from '../../components/TestimonialBanner';
import News from './News';

class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mainDropdown: false,
    };

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.addWrapperRef = this.addWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mouseup', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mouseup', this.handleClickOutside);
  }

  getHeaderImage() {
    if (!this.headerImage) {
      this.headerImage = sample(get(this.props.page, 'header_images'));
    }
    const url = buildThumbnailUrl(get(this.headerImage, 'contentUrl'), { width: 2000, height: 2000 });
    return { backgroundImage: `url('${url}')` };
  }

  toggleDropdown(e) {
    e.preventDefault();

    this.setState({
      mainDropdown: !this.state.mainDropdown,
    });
  }

  closeDropdown() {
    this.setState({
      mainDropdown: false,
    });
  }

  addWrapperRef(node) {
    if (!this.wrapperRefs) {
      this.wrapperRefs = [];
    }
    this.wrapperRefs.push(node);
  }

  handleClickOutside(event) {
    if (this.wrapperRefs && !this.wrapperRefs.find(ref => ref && ref.contains(event.target))) {
      this.closeDropdown();
    }
  }

  render() {
    const { builder, page } = this.props;

    if (!builder || !page) {
      return null;
    }
    return (
      <div className="Index">
        <PageHelmet page={page} />
        <Header />
        {/* Turn into ImageBanner Component */}
        <div className="text-center image-banner" style={this.getHeaderImage()}>
          <div className="image-banner-content">
            <h2>
              Welcome to Your New Home,<br />
              The <span>Foundation</span> of Your Life
            </h2>
            <div className="main-image-link">
              <Link name="communities" className="link">
                Find Your New Home
              </Link>
            </div>
          </div>
          <div className="overlay" />
        </div>
        {/* Turn into ImageBanner Component */}

        <div className="home-content-wrapper">
          <div className="container py-5">
            <div className="col-8 mx-auto home-content">
              <h1 className="text-center">
                <span dangerouslySetInnerHTML={SanitizeHtml(get(page, 'home_content[0].headline'))} /><br />
                <span className="callout" dangerouslySetInnerHTML={SanitizeHtml(get(page, 'home_content[0].subhead'))} />
              </h1>
              <div className="text-center" dangerouslySetInnerHTML={SanitizeHtml(get(page, 'home_content[0].text'))} />
            </div>
          </div>
        </div>
        <CtaBanner />
        <TestimonialBanner />
        <News />
        <Footer />
      </div>
    );
  }
}

Index.propTypes = {
  page: PropTypes.object,
  builder: PropTypes.object,
};

Index.defaultProps = {
  page: undefined,
  builder: undefined,
};

export default withData({
  builder: true,
  page: 'home_page',
})(Index);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/index.js